import Animation from './animation'

/*
 * This animation removes a breakdown animation using a two-part split when there is
 * a single serie displayed.
 */
class RemoveBreakdownSplitAnimation extends Animation {

  constructor (options) {
    super(options)
    this.twoPart = true
    this.ripple = true
  }

  match (serie) {
    return !this.seriesChanged &&
           !this.chart.previous.layout.breakdown.calculated && // Previously didn't have a calculated breakdown
           this.chart.layout.breakdown.calculated &&  // Now we do
           this.series.size() === 1 // We are showing just a single serie.
  }

  _timingScale () {
    // The timing should be based on the previous data
    return this.previous.scalers.x.groupScale
  }

  animate (serie, entering, selection, merged, exiting) {
    // Put the entering nodes in the dom
    this._insertHidden(entering, serie)

    // Grab the entering node's dimensions
    let dim = this._getDimensions(entering)

    // Collect all the exiting points from each of the old series and form a new selection
    this._join(exiting.selection(), dim)
        .end()
        .then(() => {
          // All bars have moved, we can show the new bar
          entering.style('opacity', 1)

          // And remove all the others
          exiting.selection().remove()
        })
  }

}

export default RemoveBreakdownSplitAnimation
